// @ts-nocheck — migrated from JS; reactstrap / react-select / layout prop friction.
import React, { Fragment, useState, useCallback } from "react";
import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";
import IntlMessages from "Util/IntlMessages";
import {
  Row,
  Card,
  CardBody,
  CardTitle,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Input,
  Label
} from "reactstrap";

export default function Modals({ className }) {
  const [state, setState] = useState({
    modal: false,
    modalWide: false,
    modalNarrow: false,
    modalLong: false,
    modalBack: false,
    backdrop: true
  });

  const toggle = useCallback(() => {
    setState((s) => ({ ...s, modal: !s.modal }));
  }, []);

  const toggleWide = useCallback(() => {
    setState((s) => ({ ...s, modalWide: !s.modalWide }));
  }, []);

  const toggleNarrow = useCallback(() => {
    setState((s) => ({ ...s, modalNarrow: !s.modalNarrow }));
  }, []);

  const toggleLong = useCallback(() => {
    setState((s) => ({ ...s, modalLong: !s.modalLong }));
  }, []);

  const toggleBack = useCallback(() => {
    setState((s) => ({ ...s, modalBack: !s.modalBack }));
  }, []);

  const changeBackdrop = useCallback((e) => {
    let value = e.target.value;
    if (value !== "static") {
      value = JSON.parse(value);
    }
    setState((s) => ({ ...s, backdrop: value }));
  }, []);

  const toggleNestedWrapper = useCallback(() => {
    setState((s) => ({
      ...s,
      modalNestedWrapper: !s.modalNestedWrapper
    }));
  }, []);

  const toggleNestedModal = useCallback(() => {
    setState((s) => ({
      ...s,
      nestedModal: !s.nestedModal,
      closeAll: false
    }));
  }, []);

  const toggleAll = useCallback(() => {
    setState((s) => ({
      ...s,
      nestedModal: !s.nestedModal,
      closeAll: true
    }));
  }, []);

  return (
    <Fragment>
      <Row>
        <Colxx xxs="12">
          <BreadcrumbContainer
            heading={<IntlMessages id="menu.modals" />}
          />
          <Separator className="mb-5" />
        </Colxx>
      </Row>

      <Row>
        <Colxx xxs="12">
          <Card className="mb-4">
            <CardBody>
              <CardTitle>
                <IntlMessages id="modal.modals-" />
              </CardTitle>
              <div>
                {/* Normal Modal Button Starts here */}
                <Button
                  className="mr-2 mb-2"
                  color="primary"
                  onClick={toggle}
                >
                  <IntlMessages id="modal.modal-normal" />
                </Button>
                {/* Normal Modal Button Ends Here */}

                {/* Large Modal Button Starts Here */}
                <Button
                  className="mr-2 mb-2"
                  color="secondary"
                  onClick={toggleLong}
                >
                  <IntlMessages id="modal.large-modal" />
                </Button>
                {/* Large Modal Button Ends Here */}
                <Modal isOpen={state.modal} toggle={toggle}>
                  <ModalHeader toggle={toggle}>
                    <IntlMessages id="modal.modal-normal" />
                  </ModalHeader>
                  <ModalBody>....</ModalBody>
                  <ModalFooter>
                    <Button color="primary" onClick={toggle}>
                      Do Something
                    </Button>{" "}
                    <Button color="secondary" onClick={toggle}>
                      Cancel
                    </Button>
                  </ModalFooter>
                </Modal>

                {/* Large Modals Data starts here */}
                <Modal isOpen={state.modalLong} toggle={toggleLong}>
                  <ModalHeader toggle={toggleLong}>
                    Modal title
                  </ModalHeader>
                  <ModalBody>
                    Cras mattis consectetur purus sit amet fermentum. Cras
                    justo odio, dapibus ac facilisis in, egestas eget quam.
                    Morbi leo risus, porta ac consectetur ac, vestibulum at
                    eros. Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur et. Vivamus sagittis lacus vel augue laoreet
                    rutrum faucibus dolor auctor. Aenean lacinia bibendum
                    nulla sed consectetur. Praesent commodo cursus magna, vel
                    scelerisque nisl consectetur et. Donec sed odio dui. Donec
                    ullamcorper nulla non metus auctor fringilla. Cras mattis
                    consectetur purus sit amet fermentum. Cras justo odio,
                    dapibus ac facilisis in, egestas eget quam. Morbi leo
                    risus, porta ac consectetur ac, vestibulum at eros.
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur et. Vivamus sagittis lacus vel augue laoreet
                    rutrum faucibus dolor auctor. Aenean lacinia bibendum
                    nulla sed consectetur. Praesent commodo cursus magna, vel
                    scelerisque nisl consectetur et. Donec sed odio dui. Donec
                    ullamcorper nulla non metus auctor fringilla. Cras mattis
                    consectetur purus sit amet fermentum. Cras justo odio,
                    dapibus ac facilisis in, egestas eget quam. Morbi leo
                    risus, porta ac consectetur ac, vestibulum at eros.
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur et. Vivamus sagittis lacus vel augue laoreet
                    rutrum faucibus dolor auctor. Aenean lacinia bibendum
                    nulla sed consectetur. Praesent commodo cursus magna, vel
                    scelerisque nisl consectetur et. Donec sed odio dui. Donec
                    ullamcorper nulla non metus auctor fringilla. Cras mattis
                    consectetur purus sit amet fermentum. Cras justo odio,
                    dapibus ac facilisis in, egestas eget quam. Morbi leo
                    risus, porta ac consectetur ac, vestibulum at eros.
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur et. Vivamus sagittis lacus vel augue laoreet
                    rutrum faucibus dolor auctor. Aenean lacinia bibendum
                    nulla sed consectetur. Praesent commodo cursus magna, vel
                    scelerisque nisl consectetur et. Donec sed odio dui. Donec
                    ullamcorper nulla non metus auctor fringilla. Cras mattis
                    consectetur purus sit amet fermentum. Cras justo odio,
                    dapibus ac facilisis in, egestas eget quam. Morbi leo
                    risus, porta ac consectetur ac, vestibulum at eros.
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur et. Vivamus sagittis lacus vel augue laoreet
                    rutrum faucibus dolor auctor. Aenean lacinia bibendum
                    nulla sed consectetur. Praesent commodo cursus magna, vel
                    scelerisque nisl consectetur et. Donec sed odio dui. Donec
                    ullamcorper nulla non metus auctor fringilla. Cras mattis
                    consectetur purus sit amet fermentum. Cras justo odio,
                    dapibus ac facilisis in, egestas eget quam. Morbi leo
                    risus, porta ac consectetur ac, vestibulum at eros.
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur et. Vivamus sagittis lacus vel augue laoreet
                    rutrum faucibus dolor auctor. Aenean lacinia bibendum
                    nulla sed consectetur. Praesent commodo cursus magna, vel
                    scelerisque nisl consectetur et. Donec sed odio dui. Donec
                    ullamcorper nulla non metus auctor fringilla.
                  </ModalBody>
                  <ModalFooter>
                    <Button color="primary" onClick={toggleLong}>
                      Do Something
                    </Button>{" "}
                    <Button color="secondary" onClick={toggleLong}>
                      Cancel
                    </Button>
                  </ModalFooter>
                </Modal>

                {/* Large Modal Data Ends Here */}
              </div>
            </CardBody>
          </Card>

          <Card className="mb-4">
            <CardBody>
              <CardTitle>
                <IntlMessages id="modal.variation-modal" />
              </CardTitle>
              <div>
                <FormGroup className="mr-2">
                  <Label for="backdrop">
                    <IntlMessages id="modal.backdrop-status" />
                  </Label>
                  <Input
                    type="select"
                    name="backdrop"
                    id="backdrop"
                    onChange={changeBackdrop}
                  >
                    <option value="true">true</option>
                    <option value="false">false</option>
                    <option value="static">"static"</option>
                  </Input>
                </FormGroup>

                <Button color="info" onClick={toggleBack}>
                  <IntlMessages id="modal.variation-modal" />
                </Button>
                <Modal
                  isOpen={state.modalBack}
                  toggle={toggleBack}
                  backdrop={state.backdrop}
                >
                  <ModalHeader toggle={toggleBack}>
                    Modal title
                  </ModalHeader>
                  <ModalBody>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                    sed do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur
                    sint occaecat cupidatat non proident, sunt in culpa qui
                    officia deserunt mollit anim id est laborum.
                  </ModalBody>
                  <ModalFooter>
                    <Button color="primary" onClick={toggleBack}>
                      Do Something
                    </Button>{" "}
                    <Button color="secondary" onClick={toggleBack}>
                      Cancel
                    </Button>
                  </ModalFooter>
                </Modal>
              </div>
            </CardBody>
          </Card>

          <Card className="mb-4">
            <CardBody>
              <CardTitle>
                <IntlMessages id="modal.nested-modal" />
              </CardTitle>
              <div>
                {/* Nested Modal Button starts here */}
                <Button
                  className="btn btn-orange mr-2 mb-2"
                  onClick={toggleNestedWrapper}
                >
                  <IntlMessages id="modal.nested-modal" />
                </Button>
                {/* Nested Modal Button Ends Here */}

                {/* Wide Modal Button Starts Here */}
                <Button className="mr-2 mb-2" onClick={toggleWide}>
                  <IntlMessages id="modal.wide-modal" />
                </Button>
                {/* Wide Modal Button Ends Here */}
                {/* Small Modal Button Starts Here */}
                <Button
                  className="mb-2 mr-2"
                  color="primary"
                  onClick={toggleNarrow}
                >
                  <IntlMessages id="modal.narrow-modal" />
                </Button>

                {/* Small Modal Button Ends Here */}

                {/* Nested Modal Content Starts Here */}
                <Modal
                  isOpen={state.modalNestedWrapper}
                  toggle={toggleNestedWrapper}
                  className={className}
                >
                  <ModalHeader toggle={toggleNestedWrapper}>
                    Modal title
                  </ModalHeader>
                  <ModalBody>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                    sed do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur
                    sint occaecat cupidatat non proident, sunt in culpa qui
                    officia deserunt mollit anim id est laborum.
                    <br />
                    <div className="text-center m-2">
                      <Button
                        className="btn btn-orange"
                        onClick={toggleNestedModal}
                      >
                        Click Me!
                      </Button>
                    </div>
                    <Modal
                      isOpen={state.nestedModal}
                      toggle={toggleNestedModal}
                      onClosed={
                        state.closeAll
                          ? toggleNestedWrapper
                          : undefined
                      }
                    >
                      <ModalHeader>Nested Modal title</ModalHeader>
                      <ModalBody>Stuff and things</ModalBody>
                      <ModalFooter>
                        <Button
                          color="primary"
                          onClick={toggleNestedModal}
                        >
                          Done
                        </Button>{" "}
                        <Button color="secondary" onClick={toggleAll}>
                          All Done
                        </Button>
                      </ModalFooter>
                    </Modal>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color="primary"
                      onClick={toggleNestedWrapper}
                    >
                      Do Something
                    </Button>{" "}
                    <Button
                      color="secondary"
                      onClick={toggleNestedWrapper}
                    >
                      Cancel
                    </Button>
                  </ModalFooter>
                </Modal>
                {/* Nested Modal Content Ends Here */}

                {/* Wide Modal Content Starts Here */}

                <Modal
                  isOpen={state.modalWide}
                  size="lg"
                  toggle={toggleWide}
                >
                  <ModalHeader toggle={toggleWide}>
                    Modal title
                  </ModalHeader>
                  <ModalBody>---</ModalBody>
                </Modal>
                {/* Wide Modal Content Ends Here */}
                {/* Small Modal Content Starts Here */}
                <Modal
                  isOpen={state.modalNarrow}
                  size="sm"
                  toggle={toggleNarrow}
                >
                  <ModalHeader toggle={toggleNarrow}>
                    Modal title
                  </ModalHeader>
                  <ModalBody>---</ModalBody>
                </Modal>
                {/* Small Modal Content Ends Here */}
              </div>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    </Fragment>
  );
}
